/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/

/**
 * Asynchronous store actions
 */

/* eslint no-console: ["error", { allow: ["info", "warn", "error"] }] */
/* eslint spaced-comment: ["error", "always", { "exceptions": ["*"] }] */
/* eslint-disable */

import LexAudioRecorder from "@/lib/lex/recorder";
import initRecorderHandlers from "@/store/recorder-handlers";
import silentOgg from "@/assets/silent.ogg";
import silentMp3 from "@/assets/silent.mp3";
import { decryptData, filterData, faqData } from "@/lib/decrypt";
import LexClient from "@/lib/lex/client";

const jwt = require("jsonwebtoken");

// var path = require('path')
// console.error('blaa', path.resolve(__dirname, '../dist'));

// const path = require('path');
// const distDir = path.join(__dirname, 'dist');
// console.error('blaa', 'vppppp');
// console.error('disDir', distDir);
// const testPath = path.dirname(__dirname, '../../..');
// console.error('testPath', testPath);
// const tenantModulePath = path.join(__dirname, '../../../dist/get-tenant-domain.js');
// console.error('tenantModulePath', tenantModulePath);
// const tenantDomainModule = require(tenantModulePath);

// non-state variables that may be mutated outside of store
// set via initializers at run time
let currentMsgIdUser;
// let previousMsgIdUser;
let adminActiveFlag;
let customerAgentId;
let missedMsgs;
let customerAgentMsgId;
let adminDisconnectFlag = 0;

let awsCredentials;
let pollyClient;
let lexClient;
let audio;
let recorder;
let handoverFlag = false;
export default {
  /***********************************************************************
   *
   * Initialization Actions
   *
   **********************************************************************/

  initCredentials(context, credentials) {
    switch (context.state.awsCreds.provider) {
      case "cognito":
        awsCredentials = credentials;
        if (lexClient) {
          lexClient.initCredentials(awsCredentials);
        }
        return context.dispatch("getCredentials");
      case "parentWindow":
        return context.dispatch("getCredentials");
      default:
        return Promise.reject(new Error("unknown credential provider"));
    }
  },
  getConfigFromParent(context) {
    // if (!context.state.isRunningEmbedded) {
    if (true) {
      return Promise.resolve({});
    }
  },
  initConfig(context, configObj) {
    context.commit("mergeConfig", configObj);
  },
  initMessageList(context) {
    context.commit("reloadMessages");
    if (context.state.messages && context.state.messages.length === 0) {
      context.commit("pushMessage", {
        type: "bot",
        text: context.state.config.lex.initialText
      });
    }
  },
  initLexClient(context, lexRuntimeClient) {
    lexClient = new LexClient({
      botName: context.state.config.lex.botName,
      botAlias: context.state.config.lex.botAlias,
      lexRuntimeClient
    });
    context.commit(
      "setLexSessionAttributes",
      context.state.config.lex.sessionAttributes
    );
    return context
      .dispatch("getCredentials")
      .then(() => lexClient.initCredentials(awsCredentials));
  },
  initPollyClient(context, client) {
    if (!context.state.recState.isRecorderEnabled) {
      return Promise.resolve();
    }
    pollyClient = client;
    context.commit("setPollyVoiceId", context.state.config.polly.voiceId);
    return context.dispatch("getCredentials").then(creds => {
      pollyClient.config.credentials = creds;
    });
  },
  initRecorder(context) {
    if (!context.state.config.recorder.enable) {
      context.commit("setIsRecorderEnabled", false);
      return Promise.resolve();
    }
    recorder = new LexAudioRecorder(context.state.config.recorder);

    return recorder
      .init()
      .then(() => recorder.initOptions(context.state.config.recorder))
      .then(() => initRecorderHandlers(context, recorder))
      .then(() => context.commit("setIsRecorderSupported", true))
      .then(() => context.commit("setIsMicMuted", recorder.isMicMuted))
      .catch(error => {
        if (
          ["PermissionDeniedError", "NotAllowedError"].indexOf(error.name) >= 0
        ) {
          console.warn("get user media permission denied");
          context.dispatch(
            "pushErrorMessage",
            "It seems like the microphone access has been denied. " +
              "If you want to use voice, please allow mic usage in your browser."
          );
        } else {
          console.error("error while initRecorder", error);
        }
      });
  },
  initBotAudio(context, audioElement) {
    if (
      !context.state.recState.isRecorderEnabled ||
      !context.state.config.recorder.enable
    ) {
      return Promise.resolve();
    }
    if (!audioElement) {
      return Promise.reject(new Error("invalid audio element"));
    }
    audio = audioElement;

    let silentSound;

    // Ogg is the preferred format as it seems to be generally smaller.
    // Detect if ogg is supported (MS Edge doesn't).
    // Can't default to mp3 as it is not supported by some Android browsers
    if (audio.canPlayType("audio/ogg") !== "") {
      context.commit("setAudioContentType", "ogg");
      silentSound = silentOgg;
    } else if (audio.canPlayType("audio/mp3") !== "") {
      context.commit("setAudioContentType", "mp3");
      silentSound = silentMp3;
    } else {
      console.error("init audio could not find supportted audio type");
      console.warn(
        "init audio can play mp3 [%s]",
        audio.canPlayType("audio/mp3")
      );
      console.warn(
        "init audio can play ogg [%s]",
        audio.canPlayType("audio/ogg")
      );
    }

    audio.preload = "auto";
    // Load a silent sound as the initial audio. This is used to workaround
    // the requirement of mobile browsers that would only play a
    // sound in direct response to a user action (e.g. click).
    // This audio should be explicitly played as a response to a click
    // in the UI
    audio.src = silentSound;
    // autoplay will be set as a response to a clik
    audio.autoplay = false;

    return Promise.resolve();
  },
  reInitBot(context) {
    if (context.state.config.lex.reInitSessionAttributesOnRestart) {
      context.commit(
        "setLexSessionAttributes",
        context.state.config.lex.sessionAttributes
      );
    }
    if (context.state.config.ui.pushInitialTextOnRestart) {
      context.commit("pushMessage", {
        type: "bot",
        text: context.state.config.lex.initialText,
        alts: {
          markdown: context.state.config.lex.initialText
        }
      });
    }
    return Promise.resolve();
  },

  /***********************************************************************
   *
   * Audio Actions
   *
   **********************************************************************/

  getAudioUrl(context, blob) {
    let url;

    try {
      url = URL.createObjectURL(blob);
    } catch (err) {
      console.error("getAudioUrl createObjectURL error", err);
      const errorMessage =
        "There was an error processing the audio " + `response: (${err})`;
      const error = new Error(errorMessage);
      return Promise.reject(error);
    }

    return Promise.resolve(url);
  },
  setAudioAutoPlay(context) {
    if (audio.autoplay) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      audio.play();
      // eslint-disable-next-line no-param-reassign
      audio.onended = () => {
        context.commit("setAudioAutoPlay", { audio, status: true });
        resolve();
      };
      // eslint-disable-next-line no-param-reassign
      audio.onerror = err => {
        context.commit("setAudioAutoPlay", { audio, status: false });
        reject(new Error(`setting audio autoplay failed: ${err}`));
      };
    });
  },
  playAudio(context, url) {
    return new Promise(resolve => {
      audio.onloadedmetadata = () => {
        context.commit("setIsBotSpeaking", true);
        context.dispatch("playAudioHandler").then(() => resolve());
      };
      audio.src = url;
    });
  },
  playAudioHandler(context) {
    return new Promise((resolve, reject) => {
      const { enablePlaybackInterrupt } = context.state.config.lex;

      const clearPlayback = () => {
        context.commit("setIsBotSpeaking", false);
        const intervalId = context.state.botAudio.interruptIntervalId;
        if (intervalId && enablePlaybackInterrupt) {
          clearInterval(intervalId);
          context.commit("setBotPlaybackInterruptIntervalId", 0);
          context.commit("setIsLexInterrupting", false);
          context.commit("setCanInterruptBotPlayback", false);
          context.commit("setIsBotPlaybackInterrupting", false);
        }
      };

      audio.onerror = error => {
        clearPlayback();
        reject(new Error(`There was an error playing the response (${error})`));
      };
      audio.onended = () => {
        clearPlayback();
        resolve();
      };
      audio.onpause = audio.onended;

      if (enablePlaybackInterrupt) {
        context.dispatch("playAudioInterruptHandler");
      }
    });
  },
  playAudioInterruptHandler(context) {
    const { isSpeaking } = context.state.botAudio;
    const {
      enablePlaybackInterrupt,
      playbackInterruptMinDuration,
      playbackInterruptVolumeThreshold,
      playbackInterruptLevelThreshold,
      playbackInterruptNoiseThreshold
    } = context.state.config.lex;
    const intervalTimeInMs = 200;

    if (
      !enablePlaybackInterrupt &&
      !isSpeaking &&
      context.state.lex.isInterrupting &&
      audio.duration < playbackInterruptMinDuration
    ) {
      return;
    }

    const intervalId = setInterval(() => {
      const { duration } = audio;
      const end = audio.played.end(0);
      const { canInterrupt } = context.state.botAudio;

      if (
        !canInterrupt &&
        // allow to be interrupt free in the beginning
        end > playbackInterruptMinDuration &&
        // don't interrupt towards the end
        duration - end > 0.5 &&
        // only interrupt if the volume seems to be low noise
        recorder.volume.max < playbackInterruptNoiseThreshold
      ) {
        context.commit("setCanInterruptBotPlayback", true);
      } else if (canInterrupt && duration - end < 0.5) {
        context.commit("setCanInterruptBotPlayback", false);
      }

      if (
        canInterrupt &&
        recorder.volume.max > playbackInterruptVolumeThreshold &&
        recorder.volume.slow > playbackInterruptLevelThreshold
      ) {
        clearInterval(intervalId);
        context.commit("setIsBotPlaybackInterrupting", true);
        setTimeout(() => {
          audio.pause();
        }, 500);
      }
    }, intervalTimeInMs);

    context.commit("setBotPlaybackInterruptIntervalId", intervalId);
  },
  getAudioProperties() {
    return audio
      ? {
          currentTime: audio.currentTime,
          duration: audio.duration,
          end: audio.played.length >= 1 ? audio.played.end(0) : audio.duration,
          ended: audio.ended,
          paused: audio.paused
        }
      : {};
  },

  /***********************************************************************
   *
   * Recorder Actions
   *
   **********************************************************************/

  startConversation(context) {
    context.commit("setIsConversationGoing", true);
    return context.dispatch("startRecording");
  },
  stopConversation(context) {
    context.commit("setIsConversationGoing", false);
  },
  startRecording(context) {
    // don't record if muted
    if (context.state.recState.isMicMuted === true) {
      console.warn("recording while muted");
      context.dispatch("stopConversation");
      return Promise.reject(new Error("The microphone seems to be muted."));
    }

    context.commit("startRecording", recorder);
    return Promise.resolve();
  },
  stopRecording(context) {
    context.commit("stopRecording", recorder);
  },
  getRecorderVolume(context) {
    if (!context.state.recState.isRecorderEnabled) {
      return Promise.resolve();
    }
    return recorder.volume;
  },

  /***********************************************************************
   *
   * Lex and Polly Actions
   *
   **********************************************************************/

  pollyGetBlob(context, text, format = "text") {
    return context
      .dispatch("refreshAuthTokens")
      .then(() => context.dispatch("getCredentials"))
      .then(creds => {
        pollyClient.config.credentials = creds;
        const synthReq = pollyClient.synthesizeSpeech({
          Text: text,
          VoiceId: context.state.polly.voiceId,
          OutputFormat: context.state.polly.outputFormat,
          TextType: format
        });
        return synthReq.promise();
      })
      .then(data => {
        const blob = new Blob([data.AudioStream], { type: data.ContentType });
        return Promise.resolve(blob);
      });
  },
  pollySynthesizeSpeech(context, text, format = "text") {
    return context
      .dispatch("pollyGetBlob", text, format)
      .then(blob => context.dispatch("getAudioUrl", blob))
      .then(audioUrl => context.dispatch("playAudio", audioUrl));
  },
  interruptSpeechConversation(context) {
    if (
      !context.state.recState.isConversationGoing &&
      !context.state.botAudio.isSpeaking
    ) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      context
        .dispatch("stopConversation")
        .then(() => context.dispatch("stopRecording"))
        .then(() => {
          if (context.state.botAudio.isSpeaking) {
            audio.pause();
          }
        })
        .then(() => {
          let count = 0;
          const countMax = 20;
          const intervalTimeInMs = 250;
          context.commit("setIsLexInterrupting", true);
          const intervalId = setInterval(() => {
            if (!context.state.lex.isProcessing) {
              clearInterval(intervalId);
              context.commit("setIsLexInterrupting", false);
              resolve();
            }
            if (count > countMax) {
              clearInterval(intervalId);
              context.commit("setIsLexInterrupting", false);
              reject(new Error("interrupt interval exceeded"));
            }
            count += 1;
          }, intervalTimeInMs);
        });
    });
  },
  playSound(context, fileUrl) {
    document.getElementById(
      "sound"
    ).innerHTML = `<audio autoplay="autoplay"><source src="${fileUrl}" type="audio/mpeg" /><embed hidden="true" autostart="true" loop="false" src="${fileUrl}" /></audio>`;
  },
  postTextMessage(context, message) {
    // const tenantDomaninNew = tenantDomainModule.getTenant();
    // console.error('tenantDomaninNew', tenantDomaninNew);
    function setNewUserMsgId(msgId) {
      // previousMsgIdUser = currentMsgIdUser;
      currentMsgIdUser = msgId;
      // console.error('Set new msg id of user to: ', currentMsgIdUser);
    }
    // function setSleepTime(sec) {
    //  return new Promise((resolve) => {
    //    setTimeout(() => resolve('waits for: '), sec);
    //  });
    // }

    if (handoverFlag === true) {
      // console.error('handed over message is ', message);

      if (message.text === "#disconnect#") {
        message.type = "bot";
        message.text =
          "You have been disconnected! Please continue with the bot.";
        message.text2 =
          "You have been disconnected! Please continue with the bot.";
        // context.dispatch('pushMessage', message);
        // console.error('message', message);
        // context.dispatch('postTextMessage', message);
        context.dispatch("pushMessage", {
          text: message.text2,
          type: message.type
        });
        handoverFlag = false;
        adminDisconnectFlag = 1;
        message.text =
          "Learner has chosen to disconnect! Please type #quit# to close the connection.";
        message.text2 =
          "Learner has chosen to disconnect! Please type #quit# to close the connection.";
      } else {
        context.dispatch("pushMessage", message);
      }
      const myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic b2xpdmUtbGVhcm5lci1zaWRlLWJvdEBjaGF0Ym90Lm9saXZlZ3JvdXAuaW86Yk9WS2diYkw4NnBVTGhIUGdIMjBmUWhJWXhLc0FHOWY="
      );
      // eslint-disable-next-line prefer-template
      const toAgebtId = "[" + customerAgentId + "]";
      const formdata = new FormData();
      formdata.append("to", toAgebtId);
      formdata.append("content", message.text);
      formdata.append("type", "private");
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow"
      };
      fetch("https://chatbot.olivegroup.io/api/v1/messages", requestOptions)
        .then(response => response.json())
        .then(id => id.id)
        .then(userMsgId => {
          const userSideMsgId = userMsgId;
          // console.error('user msg id', userSideMsgId);
          setNewUserMsgId(userSideMsgId);
          if (adminActiveFlag !== 1) {
            console.error("123");
            // getNewMsgId();
          }
          // let k = 0;
          // while (k === 0) {
          // eslint-disable-next-line no-loop-func
          //  setTimeout(() => {
          //    k = getNewMsgId(666).then((val) => { console.error('promise val', val); });
          //    console.error('k value', k);
          //  }, 7000);
          //  break;
          // }
        });
      return 0;
    } else if (context.state.isSFXOn && !context.state.lex.isPostTextRetry) {
      context.dispatch("playSound", context.state.config.ui.messageSentSFX);
      context.dispatch("sendMessageToParentWindow", { event: "messageSent" });
    }

    return context
      .dispatch("interruptSpeechConversation")
      .then(() =>
        context.dispatch("pushMessage", {
          text: message.text2,
          type: message.type
        })
      )
      .then(() => context.commit("pushUtterance", message.text))
      .then(() => context.dispatch("lexPostText", message.text))
      .then(response => {
        // check for an array of messages

        if (response.message && response.message.includes('{"messages":')) {
          const tmsg = JSON.parse(response.message);
          if (tmsg && Array.isArray(tmsg.messages)) {
            tmsg.messages.forEach((mes, index) => {
              let alts = JSON.parse(
                response.sessionAttributes.appContext || "{}"
              ).altMessages;
              if (mes.type === "CustomPayload") {
                if (alts === undefined) {
                  alts = {};
                }
                alts.markdown = mes.value;
              }
              context.dispatch("pushMessage", {
                text: mes.value,
                type: "bot",
                dialogState: context.state.lex.dialogState,
                responseCard:
                  tmsg.messages.length - 1 === index // attach response card only
                    ? context.state.lex.responseCard
                    : undefined, // for last response message
                alts
              });
            });
          }
        } else {
          let alts = JSON.parse(response.sessionAttributes.appContext || "{}")
            .altMessages;
          let responseCardObject = JSON.parse(
            response.sessionAttributes.appContext || "{}"
          ).responseCard;
          if (response.messageFormat === "CustomPayload") {
            if (alts === undefined) {
              alts = {};
            }
            alts.markdown = response.message;
          }
          if (responseCardObject === undefined) {
            responseCardObject = context.state.lex.responseCard;
          }

          context.dispatch("pushMessage", {
            text: response.message,
            type: "bot",
            slots: response.slots ? response.slots : null,
            intentName: response.intentName,
            slotToElicit: response.slotToElicit ? response.slotToElicit : null,
            dialogState: context.state.lex.dialogState,
            sessionAttributes: context.state.lex.sessionAttributes
              ? context.state.lex.sessionAttributes
              : null,
            responseCard: responseCardObject, // prefering appcontext over lex.responsecard
            alts
          });
        }
      })
      .then(() => {
        if (context.state.isSFXOn) {
          context.dispatch(
            "playSound",
            context.state.config.ui.messageReceivedSFX
          );
          context.dispatch("sendMessageToParentWindow", {
            event: "messageReceived"
          });
        }
        if (context.state.lex.dialogState === "Fulfilled") {
          context.dispatch("reInitBot");
        }
        if (context.state.isPostTextRetry) {
          context.commit("setPostTextRetry", false);
        }
      })
      .catch(error => {
        if (
          error.message.indexOf("permissible time") === -1 ||
          context.state.config.lex.retryOnLexPostTextTimeout === false ||
          (context.state.lex.isPostTextRetry &&
            context.state.lex.retryCountPostTextTimeout >=
              context.state.config.lex.retryCountPostTextTimeout)
        ) {
          context.commit("setPostTextRetry", false);
          const errorMessage = context.state.config.ui.showErrorDetails
            ? ` ${error}`
            : "";
          console.error("error in postTextMessage", error);
          context.dispatch(
            "pushErrorMessage",
            "Sorry, I was unable to process your message. Try again later." +
              `${errorMessage}`
          );
        } else {
          context.commit("setPostTextRetry", true);
          context.dispatch("postTextMessage", message);
        }
      });
  },
  deleteSession(context) {
    context.commit("setIsLexProcessing", true);
    return context
      .dispatch("refreshAuthTokens")
      .then(() => context.dispatch("getCredentials"))
      .then(() => lexClient.deleteSession())
      .then(data => {
        context.commit("setIsLexProcessing", false);
        return context
          .dispatch("updateLexState", data)
          .then(() => Promise.resolve(data));
      })
      .catch(error => {
        console.error(error);
        context.commit("setIsLexProcessing", false);
      });
  },
  startNewSession(context) {
    context.commit("setIsLexProcessing", true);
    return context
      .dispatch("refreshAuthTokens")
      .then(() => context.dispatch("getCredentials"))
      .then(() => lexClient.startNewSession())
      .then(data => {
        context.commit("setIsLexProcessing", false);
        return context
          .dispatch("updateLexState", data)
          .then(() => Promise.resolve(data));
      })
      .catch(error => {
        console.error(error);
        context.commit("setIsLexProcessing", false);
      });
  },
  lexPostText(context, text) {
    context.commit("setIsLexProcessing", true);
    context.commit("reapplyTokensToSessionAttributes");
    const session = context.state.lex.sessionAttributes;
    delete session.appContext;
    return context
      .dispatch("refreshAuthTokens")
      .then(() => context.dispatch("getCredentials"))
      .then(() => lexClient.postText(text, session))
      .then(data => {
        context.commit("setIsLexProcessing", false);
        return context
          .dispatch("updateLexState", data)
          .then(() => Promise.resolve(data));
      })
      .catch(error => {
        context.commit("setIsLexProcessing", false);
        throw error;
      });
  },
  lexPostContent(context, audioBlob, offset = 0) {
    context.commit("setIsLexProcessing", true);
    context.commit("reapplyTokensToSessionAttributes");
    const session = context.state.lex.sessionAttributes;
    delete session.appContext;
    console.info("audio blob size:", audioBlob.size);
    let timeStart;

    return context
      .dispatch("refreshAuthTokens")
      .then(() => context.dispatch("getCredentials"))
      .then(() => {
        timeStart = performance.now();
        return lexClient.postContent(
          audioBlob,
          session,
          context.state.lex.acceptFormat,
          offset
        );
      })
      .then(lexResponse => {
        const timeEnd = performance.now();
        console.info(
          "lex postContent processing time:",
          ((timeEnd - timeStart) / 1000).toFixed(2)
        );
        context.commit("setIsLexProcessing", false);
        return context
          .dispatch("updateLexState", lexResponse)
          .then(() =>
            context.dispatch("processLexContentResponse", lexResponse)
          )
          .then(blob => Promise.resolve(blob));
      })
      .catch(error => {
        context.commit("setIsLexProcessing", false);
        throw error;
      });
  },
  processLexContentResponse(context, lexData) {
    const { audioStream, contentType, dialogState } = lexData;

    return Promise.resolve().then(() => {
      if (!audioStream || !audioStream.length) {
        const text =
          dialogState === "ReadyForFulfillment"
            ? "All done"
            : "There was an error";
        return context.dispatch("pollyGetBlob", text);
      }

      return Promise.resolve(new Blob([audioStream], { type: contentType }));
    });
  },
  updateLexState(context, lexState) {
    const lexStateDefault = {
      dialogState: "",
      inputTranscript: "",
      intentName: "",
      message: "",
      responseCard: null,
      sessionAttributes: {},
      slotToElicit: "",
      slots: {}
    };
    // simulate response card in sessionAttributes
    // used mainly for postContent which doesn't support response cards
    if (
      "sessionAttributes" in lexState &&
      "appContext" in lexState.sessionAttributes
    ) {
      try {
        const appContext = JSON.parse(lexState.sessionAttributes.appContext);
        if ("responseCard" in appContext) {
          lexStateDefault.responseCard = appContext.responseCard;
        }
      } catch (e) {
        const error = new Error(
          `error parsing appContext in sessionAttributes: ${e}`
        );
        return Promise.reject(error);
      }
    }
    context.commit("updateLexState", { ...lexStateDefault, ...lexState });
    if (context.state.isRunningEmbedded) {
      context.dispatch("sendMessageToParentWindow", {
        event: "updateLexState",
        state: context.state.lex
      });
    }
    return Promise.resolve();
  },

  /***********************************************************************
   *
   * Message List Actions
   *
   **********************************************************************/

  pushMessage(context, message) {
    function asyncThing1() {
      return new Promise(resolve => {
        setTimeout(() => resolve("Thing 1 is done!"), 10000);
      });
    }
    function setAdminDisconnectFlag() {
      adminDisconnectFlag = 1;
    }
    function displayAdminMsg(msg) {
      // console.error('admin msg', msg);
      // console.error('admin msg content', msg.content);
      // console.error('splited msg', msg.content.slice(3, 9));
      // if (msg.content.slice(3, 9) === '#quit#') {
      console.error("msg", msg.content.slice(3, 11));
      if (
        msg.content.slice(3, 9) === "#quit#" ||
        msg.content.slice(3, 11) === "#logout#"
      ) {
        handoverFlag = false;
        adminDisconnectFlag = 1;
        const disconnectMsg =
          "Agent disconnected! Please continue with the bot.";
        context.dispatch("pushMessage", {
          type: "bot",
          text: disconnectMsg,
          text2: disconnectMsg
        });
      } else if (adminDisconnectFlag === 0) {
        context.dispatch("pushMessage", {
          type: "bot",
          text: msg.content,
          text2: msg.content
        });
      }
    }
    async function getNewMsgId() {
      adminActiveFlag = 1;
      const thing1 = await asyncThing1();
      console.error("sleep ", thing1);
      const myHeaders2 = new Headers();
      myHeaders2.append(
        "Authorization",
        "Basic b2xpdmUtYWdlbnQtc2lkZS1ib3RAY2hhdGJvdC5vbGl2ZWdyb3VwLmlvOlZkclJ3Zmo3TnlScnEwNWRObmo4bW5vcXR2NVRRd29M"
      );
      const requestOptions2 = {
        method: "GET",
        headers: myHeaders2,
        redirect: "follow"
      };
      const linkPart1 =
        'https://chatbot.olivegroup.io/api/v1/messages?num_before=10&num_after=0&anchor=newest&narrow=[{"operator": "pm-with","operand":[';
      const linkPart2 = "]}]";
      let msgFetchUrl = linkPart1.concat(customerAgentId);
      msgFetchUrl = msgFetchUrl.concat(linkPart2);
      return fetch(msgFetchUrl, requestOptions2)
        .then(response => response.json())
        .then(newAdminMsgId => {
          console.error("response", newAdminMsgId.messages);
          const messageLength = newAdminMsgId.messages.length;
          const newMsgId = newAdminMsgId.messages[messageLength - 1].id;
          console.error(
            "content",
            newAdminMsgId.messages[messageLength - 1].content
          );
          console.error("id", newMsgId);
          if (newMsgId > customerAgentMsgId) {
            // eslint-disable-next-line max-len
            const newAdminMsgs = newAdminMsgId.messages.filter(
              AdmMsg => AdmMsg.id > customerAgentMsgId
            );
            newAdminMsgs.forEach(displayAdminMsg);
            customerAgentMsgId = newMsgId;
            // if (newAdminMsgId.messages[messageLength - 1].content.slice(3, 9) === '#quit#') {
            if (
              newAdminMsgId.messages[messageLength - 1].content.slice(3, 9) ===
                "#quit#" ||
              newAdminMsgId.messages[messageLength - 1].content.slice(3, 11) ===
                "#logout#"
            ) {
              console.error("inside quit", "true");
              setAdminDisconnectFlag();
              return 0;
            }
            if (adminDisconnectFlag === 0) {
              getNewMsgId();
              // setTimeout(getNewMsgId(currentMsgIdUser), 5000);
            }
          }
          if (adminDisconnectFlag === 0) {
            getNewMsgId();
            // setTimeout(getNewMsgId(currentMsgIdUser), 5000);
          }
          return 0;
        });
    }
    if (handoverFlag === false) {
      const msgFromBot = message.text;
      if (msgFromBot.slice(0, 8) === "https://") {
        window.open(msgFromBot);
      } else if (msgFromBot.slice(0, 11) === "$chate_007$") {
        handoverFlag = true;
        adminDisconnectFlag = 0;
        [customerAgentId, customerAgentMsgId, missedMsgs] = [
          msgFromBot.split("***")[1],
          msgFromBot.split("***")[2],
          msgFromBot.split("***")[3]
        ];
        console.error("agent id and msg id", [
          customerAgentId,
          customerAgentMsgId,
          missedMsgs
        ]);
        getNewMsgId();
        /*
        context.commit("pushMessage", {
          text: 'Connected with agent, Say "Hi"',
          type: message.type
        });
        */
        // customerAgentMsgId = msgFromBot.split(' ')[2];

        if (missedMsgs !== ".") {
          const spltedMsgLst = missedMsgs.split("#$newLine$#");
          let spltdMsgIndx;
          // eslint-disable-next-line no-plusplus
          for (
            spltdMsgIndx = 0;
            spltdMsgIndx < spltedMsgLst.length;
            spltdMsgIndx++
          ) {
            context.commit("pushMessage", {
              text: spltedMsgLst[spltdMsgIndx],
              type: message.type
            });
          }
        }
      } else if (context.state.lex.isPostTextRetry === false) {
        if (message.type === "bot") {
          // console.error('msg', message);
          /*
          {type: "bot", text: "Agent disconnected! Please continue with the bot.", 
            text2: "Agent disconnected! Please continue with the bot.",type: "bot"}
          */

          let msg = { ...message };
          /*
          msg.text =
            "OTP Verified Successfully #$newLine$# 1 : 5. Construction, Planning and the Built Environment\n2 : AIPMT\n3 : Administrator\n4 : As I Am\n5 : Assessment\n6 : Astrophysics\n7 : Blank Course (Olive Test)\n8 : Business Administrator\n9 : CA Courses\n10 : CATEGORIES 1\n11 : Computer\n12 : Computer Science\n13 : Dance\n14 : Data Analytics\n15 : Data mining\n16 : Demo Category\n17 : Digital Marketing\n18 : Diploma Courses\n19 : English\n20 : F1\n21 : F2\n22 : First Aid\n23 : General\n24 : Hosp\n25 : IPCC\n26 : IT SKILS\n27 : Introduction Courses\n28 : JL Test\n29 : Java\n30 : Jordan Test\n31 : Language Courses\n32 : Live class\n33 : MBA\n34 : Mathematics\n35 : Mobile App Test Category\n36 : Mobile Technology\n37 : NATA\n38 : Office\n39 : Olive\n40 : Org structure\n41 : PMP2\n42 : Physics\n43 : Protective Services\n44 : QA\n45 : Quantitative Aptitude\n46 : Quantitative Aptitude  CATEGORIES\n47 : Quantitative Aptitude 2\n48 : Quantitative Aptitude 3\n49 : Quantitative Aptitude category\n50 : Sample\n51 : Sample_Check\n52 : Spanish Courses\n53 : Sports\n54 : TOEFL\n55 : Test demo\n56 : Test v\n57 : Testing UAT\n58 : Tr or Fal-cat\n59 : Training Courses\n60 : abc\n61 : abcd\n62 : alex cat\n63 : engineering\n64 : iOS test\n65 : java test\n66 : mp\n67 : qwerrty\n68 : test\n69 : test cyber security\n70 : testcategoryjo\n#$newLine$#Please type in the interested category numbers separated by comma (,)";
          msg.intentName = "saveCategory";
          */

          /* Check if that message is for FAQ. Then modify it's text message and generate faqcontent variable */
          var faqPatt = /\{\{.*?\}\}/g;
          if (faqPatt.test(msg.text)) {
            msg = faqData(msg);
            let pushMessage = {
              type: msg.type,
              text: msg.introMsg,
              keywords: "faq-bot-answer",
              thumbnailURL: null,
              faqcontent: msg.faqcontent ? msg.faqcontent : null,
              intentName: msg.intentName,

              sessionAttributes: msg.sessionAttributes
                ? msg.sessionAttributes
                : null
            };
            context.commit("pushMessage", pushMessage);
            return false;
          }

          /*
          Modify Invalid message 
          invalid_entry: "email/phone"
          */
          if (
            msg.sessionAttributes &&
            msg.sessionAttributes["invalid_entry"] &&
            msg.slots &&
            msg.slots.hasOwnProperty(msg.sessionAttributes["invalid_entry"])
          ) {
            msg.text =
              "Your " +
              msg.sessionAttributes["invalid_entry"] +
              " is invalid. \n" +
              msg.text;
          }

          const splitedMessageList = msg.text.split("#$newLine$#");
          // console.error('splited msg', splitedMessageList);

          const responseCardTemp = msg.responseCard;

          /* 
          *************************
          Course Informaton
          *************************
          If it is Course Detail Information not needto send message but instead of showing block 
          */

          if (
            message.sessionAttributes &&
            message.sessionAttributes.landing_action &&
            message.sessionAttributes.landing_action === "course_info" &&
            message.responseCard != null
          ) {
            let pushMessage = {
              type: message.type,
              keywords: "courseinfo",
              objData: decryptData(message, "courseinfo"),
              thumbnailURL:
                message.responseCard &&
                message.responseCard.genericAttachments &&
                message.responseCard.genericAttachments.length > 0
                  ? message.responseCard.genericAttachments[0].imageUrl
                  : null,
              intentName: message.intentName
            };
            context.commit("pushMessage", pushMessage);
            return false;
          }

          /* 
          *************************
          My Course Informaton
          *************************
          Course Detail information of My Courses
          */
          let hasCourseInfo =
            msg.intentName &&
            msg.intentName === "nextCarousel" &&
            msg.sessionAttributes &&
            msg.sessionAttributes.landing_action &&
            (msg.sessionAttributes.landing_action === "my courses" ||
              msg.sessionAttributes.landing_action === "my_bundle_courses")
              ? true
              : false;

          let hasResponseCard = !msg.responseCard ? false : true;
          if (hasCourseInfo && !hasResponseCard) {
            let objData = decryptData(msg, "courseinfo");
            objData.title = context.state.activeCourse.title;
            objData.imageUrl = context.state.activeCourse.imageUrl;

            let pushMessage = {
              type: msg.type,
              keywords: "mycourseinfo",
              objData: objData,
              thumbnailURL:
                msg.responseCard &&
                msg.responseCard.genericAttachments &&
                msg.responseCard.genericAttachments.length > 0
                  ? msg.responseCard.genericAttachments[0].imageUrl
                  : null,
              intentName: msg.intentName
            };
            context.commit("pushMessage", pushMessage);
            return false;
          }

          let splitMsgIndex;
          // eslint-disable-next-line no-plusplus

          for (
            splitMsgIndex = 0;
            splitMsgIndex < splitedMessageList.length;
            splitMsgIndex++
          ) {
            let keywords = "";
            var objData = null;

            /* Detecting word pharse to identify it is welcom message */
            let patt = /virtual agent/g;
            keywords = patt.test(message.text) ? "welcome" : "";

            // Response Card need to show only at last index
            let pushMessage = {
              text: splitedMessageList[splitMsgIndex],
              type: message.type,
              keywords: keywords,
              index: splitMsgIndex,
              dialogState: message.dialogState ? message.dialogState : null,
              faqcontent: message.faqcontent ? message.faqcontent : null,
              intentName: message.intentName ? message.intentName : null,
              slots: message.slots ? message.slots : null,
              slotToElicit: message.slotToElicit ? message.slotToElicit : null,
              sessionAttributes: message.sessionAttributes
                ? message.sessionAttributes
                : null,
              responseCard:
                splitMsgIndex === splitedMessageList.length - 1
                  ? responseCardTemp
                  : null
            };

            context.commit("pushMessage", pushMessage);
          }
          /* Modified message end */
        } else {
          context.commit("pushMessage", message);
        }
      }
    } else if (handoverFlag === true) {
      console.error("handover", message);
      context.commit("pushMessage", message);
    }
  },
  pushErrorMessage(context, text, dialogState = "Failed") {
    context.commit("pushMessage", {
      type: "bot",
      text,
      dialogState
    });
  },

  /***********************************************************************
   *
   * Credentials Actions
   *
   **********************************************************************/

  getCredentialsFromParent(context) {
    const expireTime =
      awsCredentials && awsCredentials.expireTime
        ? awsCredentials.expireTime
        : 0;
    const credsExpirationDate = new Date(expireTime).getTime();
    const now = Date.now();
    if (credsExpirationDate > now) {
      return Promise.resolve(awsCredentials);
    }
    return context
      .dispatch("sendMessageToParentWindow", { event: "getCredentials" })
      .then(credsResponse => {
        if (
          credsResponse.event === "resolve" &&
          credsResponse.type === "getCredentials"
        ) {
          return Promise.resolve(credsResponse.data);
        }
        const error = new Error("invalid credential event from parent");
        return Promise.reject(error);
      })
      .then(creds => {
        const { AccessKeyId, SecretKey, SessionToken } = creds.data.Credentials;
        const { IdentityId } = creds.data;
        // recreate as a static credential
        awsCredentials = {
          accessKeyId: AccessKeyId,
          secretAccessKey: SecretKey,
          sessionToken: SessionToken,
          identityId: IdentityId,
          expired: false,
          getPromise() {
            return Promise.resolve(awsCredentials);
          }
        };

        return awsCredentials;
      });
  },
  getCredentials(context) {
    if (context.state.awsCreds.provider === "parentWindow") {
      return context.dispatch("getCredentialsFromParent");
    }
    return awsCredentials.getPromise().then(() => awsCredentials);
  },

  /***********************************************************************
   *
   * Auth Token Actions
   *
   **********************************************************************/

  refreshAuthTokensFromParent(context) {
    return context
      .dispatch("sendMessageToParentWindow", { event: "refreshAuthTokens" })
      .then(tokenResponse => {
        if (
          tokenResponse.event === "resolve" &&
          tokenResponse.type === "refreshAuthTokens"
        ) {
          return Promise.resolve(tokenResponse.data);
        }
        if (context.state.isRunningEmbedded) {
          const error = new Error("invalid refresh token event from parent");
          return Promise.reject(error);
        }
        return Promise.resolve("outofbandrefresh");
      })
      .then(tokens => {
        if (context.state.isRunningEmbedded) {
          context.commit("setTokens", tokens);
        }
        return Promise.resolve();
      });
  },
  refreshAuthTokens(context) {
    function isExpired(token) {
      if (token) {
        const decoded = jwt.decode(token, { complete: true });
        if (decoded) {
          const now = Date.now();
          // calculate and expiration time 5 minutes sooner and adjust to milliseconds
          // to compare with now.
          const expiration = (decoded.payload.exp - 5 * 60) * 1000;
          if (now > expiration) {
            return true;
          }
          return false;
        }
        return false;
      }
      return false;
    }

    if (
      context.state.tokens.idtokenjwt &&
      isExpired(context.state.tokens.idtokenjwt)
    ) {
      console.info("starting auth token refresh");
      return context.dispatch("refreshAuthTokensFromParent");
    }
    return Promise.resolve();
  },

  /***********************************************************************
   *
   * UI and Parent Communication Actions
   *
   **********************************************************************/

  toggleIsUiMinimized(context) {
    context.commit("toggleIsUiMinimized");
    return context.dispatch("sendMessageToParentWindow", {
      event: "toggleMinimizeUi"
    });
  },
  toggleIsLoggedIn(context) {
    context.commit("toggleIsLoggedIn");
    return context.dispatch("sendMessageToParentWindow", {
      event: "toggleIsLoggedIn"
    });
  },
  toggleHasButtons(context) {
    context.commit("toggleHasButtons");
    return context.dispatch("sendMessageToParentWindow", {
      event: "toggleHasButtons"
    });
  },
  toggleIsSFXOn(context) {
    context.commit("toggleIsSFXOn");
  },
  /**
   * sendMessageToParentWindow will either dispatch an event using a CustomEvent to a handler when
   * the lex-web-ui is running as a VUE component on a page or will send a message via postMessage
   * to a parent window if an iFrame is hosting the VUE component on a parent page.
   * isRunningEmbedded === true indicates running withing an iFrame on a parent page
   * isRunningEmbedded === false indicates running as a VUE component directly on a page.
   * @param context
   * @param message
   * @returns {Promise<any>}
   */
  sendMessageToParentWindow(context, message) {
    if (!context.state.isRunningEmbedded) {
      return new Promise((resolve, reject) => {
        try {
          const myEvent = new CustomEvent("fullpagecomponent", {
            detail: message
          });
          document.dispatchEvent(myEvent);
          resolve(myEvent);
        } catch (err) {
          reject(err);
        }
      });
    }
    return new Promise((resolve, reject) => {
      const messageChannel = new MessageChannel();
      messageChannel.port1.onmessage = evt => {
        messageChannel.port1.close();
        messageChannel.port2.close();
        if (evt.data.event === "resolve") {
          resolve(evt.data);
        } else {
          const errorMessage = `error in sendMessageToParentWindow: ${evt.data.error}`;
          reject(new Error(errorMessage));
        }
      };
      // let target = context.state.config.ui.parentOrigin;
      let target = window.location.origin;
      if (target !== window.location.origin) {
        // simple check to determine if a region specific path has been provided
        const p1 = context.state.config.ui.parentOrigin.split(".");
        const p2 = window.location.origin.split(".");
        if (p1[0] === p2[0]) {
          target = window.location.origin;
        }
      }
      window.parent.postMessage(message, target, [messageChannel.port2]);
    });
  },
  resetHistory(context) {
    context.commit("clearMessages");
    context.commit("pushMessage", {
      type: "bot",
      text: context.state.config.lex.initialText,
      alts: {
        markdown: context.state.config.lex.initialText
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js